import React, { useState } from "react";
import Sara from "../assets/Saraz.jpg";
import { Container, Row, Col, Button } from "react-bootstrap";
import SingleCard from "./Card";
import LogoSilmov from "../assets/Silmov.png";

const Main = () => {
  const [modalShow, setModalShow] = React.useState(false);
  const [openMenu, setOpenMenu] = useState(false);

  const handleModalShow = (e) => {
    setModalShow(!modalShow);
    if (e) {
      const sez = e.target.id;
      localStorage.setItem("sez", sez);
    }
  };

  const handleMenu = () => {
    setOpenMenu(!openMenu);
  };

  return (
       
      <div id="container" className="d-flex flex-column textFormat">         
        <div className="RowOdd">
          <div className="pageContent">            
            <Row>
              <Col xs={12} md={6} className="myCol">
                <SingleCard
                  title="Chi è il massoterapista MCB"                  
                  text="Il Massaggiatore Capo Bagnino degli Stabilimenti Idroterapici
                  (Massaggiatore Terapista e Idroterapista) è abilitato
                  all'esercizio dell'Arte Ausiliaria delle Professioni Sanitarie:
                  dietro prescizione medica per le prestazioni terapeutiche e in
                  piena autonomia per le pratiche di massaggio benessere e
                  sportivo."
                  subtext="(Art.1 R.D. n°1334 del 31/05/1928 - Art.99 R.D. n°1265 del 27/07/1934 - Art.1 D.P.R. n°10 del 15/01/1972)"
                />   
              </Col>
              <Col xs={12} md={6} className="myCol">
                <SingleCard
                  title="Cosa è la Massoterapia"                  
                  text="La massoterapia comprende varie tecniche di massaggio, aventi lo
                  scopo di promuovere la salute e il benessere di diversi apparati
                  del corpo umano, tra cui principalmente l'apparato
                  muscolo-scheletrico."
                />                 
              </Col>            
            </Row>        
          </div>
        </div>

        <Row>
          <div>
            <h2 className="my-4 sectionTitle" id="trattamenti">Trattamenti</h2>            
          </div>          
        </Row>

        <div className="RowEven">
          <div className="pageContent">
            <Row>
              <Col xs={12} md={6} className="myCol">
                <SingleCard
                  title="Linfodrenaggio Vodder"                  
                  text="Il massaggio linfodrenante è un particolare tipo di massaggio il cui scopo è quello di favorire 
                  il drenaggio dei fluidi linfatici riducendone i ristagni attraverso la stimolazione della circolazione 
                  linfatica. Il principale beneficio è contrastare il gonfiore e l'edema che tipicamente si manifestano 
                  quando la circolazione linfatica non è ottimale. Utilizzato frequentemente anche come trattamento 
                  post-infortunio ed anche nel post-intervento 
                  chirurgico laddove si presentano edema e/o gonfiore."
                />    
                <div id="LogoSilmov">
                  <p>Attestato Certificato</p>
                  <img src={LogoSilmov}/>
                  <p>Livelli I e II</p>
                </div>
              </Col>
              <Col xs={12} md={6} className="myCol">
                <SingleCard
                  title="Trattamento Craniosacrale"                  
                  text="Il trattamento cranio-sacrale è una tecnica di natura osteopatica. 
                  Mediante leggere manipolazioni, 
                  l’operatore interagisce con l’impulso ritmico craniale; quest'ultimo è una 
                  componente fisiologica che, grazie al liquor cefalorachidiano, comunica con il sistema nervoso centrale. 
                  Questo trattamento agisce profondamente sul sistema nervoso, 
                  favorisce l’armonia degli stati psicologici ed emotivi. Il trattamento cranio-sacrale 
                  è delicato e sicuro e si può eseguire anche su 
                  donne in gravidanza, persone in stato post-operatorio o che stanno affrontanto una riabilitazione post traumatica."
                />                 
              </Col>
            </Row>
          </div>
        </div>

        <div className="RowOdd">
          <div className="pageContent">
            <Row>
              <Col xs={12} md={6} className="myCol">
                <SingleCard
                  title="Massaggio Decontratturante"                  
                  text="Il massaggio decontratturante è un tipo di massaggio il cui scopo è quello di sciogliere le contratture muscolari;
                   esse sono contrazioni involontarie insistenti e dolorose di uno o più muscoli scheletrici che si presentano 
                   rigidi con ipertonia delle fibre muscolari apprezzabili al tatto. Gli obiettivi che si vogliono raggiungere 
                   sono allentare le tensioni muscolari tipiche di questo disturbo, ridurre il dolore, velocizzare i tempi di 
                   recupero; viene inoltre favorita le circolazione sanguigna e linfatica."
                />                  
              </Col>
              <Col xs={12} md={6} className="myCol">
                <SingleCard
                  title="Massaggio Miorilassante"                  
                  text="Questa tipologia di massaggio racchiude e fonde diverse manualità che hanno origine da tecniche di massaggio 
                  finalizzate al rilassamento sia dei tessuti superficiali, sia di quelli profondi. Gli obiettivi sono: 
                  il raggiungimento di uno stato di rilassamento psicofisico con conseguente attenuazione di tensioni 
                  fisiche ed emotive, l'abbassamento dello stress, una migliore circolazione di tutti i liquidi corporei, 
                  una migliore respirazione ed una migliore percezione del proprio corpo."
                />   
              </Col>
            </Row>
          </div>
        </div>

        <div className="RowEven">
          <div className="pageContent">
            <Row>
              <Col xs={12} md={6} className="myCol">
                <SingleCard
                  title="Bendaggio Funzionale"                  
                  text="Il bendaggio funzionale è una tecnica di immobilizzazione parziale volta a ridurre i tempi 
                  di guarigione rispetto alle metodiche di immobilizzazione tradizionali. Un'articolazione 
                  viene infatti messa in scarico e protetta, soltanto nella direzione di movimento 
                  dolorosa o patologica."
                />                  
              </Col>
              <Col xs={12} md={6} className="myCol">
                <SingleCard
                  title="Kinesio Taping"                  
                  text="Il Taping neuro-muscolare è una tecnica che consiste nell’applicazione di un nastro adesivo elastico 
                  (tape) sulla cute, con effetto diretto locale e a distanza per via riflessa. Gli effetti principali di questo trattamento                  
                  sono: alleviare il dolore, normalizzare la tensione muscolare, migliorare la vascolararizzazione sanguinea e
                  rimuovere la congestione vensosa e linfatica"
                />               
              </Col>
            </Row>
          </div>
        </div>

        <div className="Row">
          <div className="pageContent">
            <Row>
              <Col className="d-flex flex-column justify-content-center align-items-center my-5"> 
                  <div>
                    <h2 className="my-4 sectionTitle" id="foto">Sara</h2>
                  </div>                                
                  <img src={Sara} id="sara" className="my-4" />                
              </Col>              
            </Row>
          </div>
        </div>
        
        
      </div>
    
  );
};

export default Main;
